import { useClientSide } from '~/hooks/common';
import useSelector from '~/store/useSelector';

function SimulateSpinnerCrash() {
  const isClientSide = useClientSide();
  const { crashSpinner } = useSelector(store => store.router.queryParams);

  if (isClientSide && crashSpinner) {
    // @ts-ignore
    window.xyz.dummy();
  }

  return null;
}

export default SimulateSpinnerCrash;
